import formatIsoDate from '@/services/general/formatIsoDate';

export function preparationEnvoiBackMandat(mandat) {
  if (!mandat) return mandat;
  return {
    ...mandat,
    dateDebut: formatIsoDate(mandat.dateDebut),
    dateFin: formatIsoDate(mandat.dateFin),
  };
}

export default function preparationEnvoiBackMandats(mandats) {
  if (!mandats || !mandats.length) return mandats;
  return mandats.map(preparationEnvoiBackMandat);
}
